import { createHash } from 'crypto';
import _ from 'lodash';
import { InvalidSysCallError, InvalidVMByteCodeError, InvalidVMStateError } from '../errors';
export var Op;
(function (Op) {
    Op[Op["PUSH0"] = 0] = "PUSH0";
    Op[Op["PUSHBYTES1"] = 1] = "PUSHBYTES1";
    Op[Op["PUSHBYTES2"] = 2] = "PUSHBYTES2";
    Op[Op["PUSHBYTES3"] = 3] = "PUSHBYTES3";
    Op[Op["PUSHBYTES4"] = 4] = "PUSHBYTES4";
    Op[Op["PUSHBYTES5"] = 5] = "PUSHBYTES5";
    Op[Op["PUSHBYTES6"] = 6] = "PUSHBYTES6";
    Op[Op["PUSHBYTES7"] = 7] = "PUSHBYTES7";
    Op[Op["PUSHBYTES8"] = 8] = "PUSHBYTES8";
    Op[Op["PUSHBYTES9"] = 9] = "PUSHBYTES9";
    Op[Op["PUSHBYTES10"] = 10] = "PUSHBYTES10";
    Op[Op["PUSHBYTES11"] = 11] = "PUSHBYTES11";
    Op[Op["PUSHBYTES12"] = 12] = "PUSHBYTES12";
    Op[Op["PUSHBYTES13"] = 13] = "PUSHBYTES13";
    Op[Op["PUSHBYTES14"] = 14] = "PUSHBYTES14";
    Op[Op["PUSHBYTES15"] = 15] = "PUSHBYTES15";
    Op[Op["PUSHBYTES16"] = 16] = "PUSHBYTES16";
    Op[Op["PUSHBYTES17"] = 17] = "PUSHBYTES17";
    Op[Op["PUSHBYTES18"] = 18] = "PUSHBYTES18";
    Op[Op["PUSHBYTES19"] = 19] = "PUSHBYTES19";
    Op[Op["PUSHBYTES20"] = 20] = "PUSHBYTES20";
    Op[Op["PUSHBYTES21"] = 21] = "PUSHBYTES21";
    Op[Op["PUSHBYTES22"] = 22] = "PUSHBYTES22";
    Op[Op["PUSHBYTES23"] = 23] = "PUSHBYTES23";
    Op[Op["PUSHBYTES24"] = 24] = "PUSHBYTES24";
    Op[Op["PUSHBYTES25"] = 25] = "PUSHBYTES25";
    Op[Op["PUSHBYTES26"] = 26] = "PUSHBYTES26";
    Op[Op["PUSHBYTES27"] = 27] = "PUSHBYTES27";
    Op[Op["PUSHBYTES28"] = 28] = "PUSHBYTES28";
    Op[Op["PUSHBYTES29"] = 29] = "PUSHBYTES29";
    Op[Op["PUSHBYTES30"] = 30] = "PUSHBYTES30";
    Op[Op["PUSHBYTES31"] = 31] = "PUSHBYTES31";
    Op[Op["PUSHBYTES32"] = 32] = "PUSHBYTES32";
    Op[Op["PUSHBYTES33"] = 33] = "PUSHBYTES33";
    Op[Op["PUSHBYTES34"] = 34] = "PUSHBYTES34";
    Op[Op["PUSHBYTES35"] = 35] = "PUSHBYTES35";
    Op[Op["PUSHBYTES36"] = 36] = "PUSHBYTES36";
    Op[Op["PUSHBYTES37"] = 37] = "PUSHBYTES37";
    Op[Op["PUSHBYTES38"] = 38] = "PUSHBYTES38";
    Op[Op["PUSHBYTES39"] = 39] = "PUSHBYTES39";
    Op[Op["PUSHBYTES40"] = 40] = "PUSHBYTES40";
    Op[Op["PUSHBYTES41"] = 41] = "PUSHBYTES41";
    Op[Op["PUSHBYTES42"] = 42] = "PUSHBYTES42";
    Op[Op["PUSHBYTES43"] = 43] = "PUSHBYTES43";
    Op[Op["PUSHBYTES44"] = 44] = "PUSHBYTES44";
    Op[Op["PUSHBYTES45"] = 45] = "PUSHBYTES45";
    Op[Op["PUSHBYTES46"] = 46] = "PUSHBYTES46";
    Op[Op["PUSHBYTES47"] = 47] = "PUSHBYTES47";
    Op[Op["PUSHBYTES48"] = 48] = "PUSHBYTES48";
    Op[Op["PUSHBYTES49"] = 49] = "PUSHBYTES49";
    Op[Op["PUSHBYTES50"] = 50] = "PUSHBYTES50";
    Op[Op["PUSHBYTES51"] = 51] = "PUSHBYTES51";
    Op[Op["PUSHBYTES52"] = 52] = "PUSHBYTES52";
    Op[Op["PUSHBYTES53"] = 53] = "PUSHBYTES53";
    Op[Op["PUSHBYTES54"] = 54] = "PUSHBYTES54";
    Op[Op["PUSHBYTES55"] = 55] = "PUSHBYTES55";
    Op[Op["PUSHBYTES56"] = 56] = "PUSHBYTES56";
    Op[Op["PUSHBYTES57"] = 57] = "PUSHBYTES57";
    Op[Op["PUSHBYTES58"] = 58] = "PUSHBYTES58";
    Op[Op["PUSHBYTES59"] = 59] = "PUSHBYTES59";
    Op[Op["PUSHBYTES60"] = 60] = "PUSHBYTES60";
    Op[Op["PUSHBYTES61"] = 61] = "PUSHBYTES61";
    Op[Op["PUSHBYTES62"] = 62] = "PUSHBYTES62";
    Op[Op["PUSHBYTES63"] = 63] = "PUSHBYTES63";
    Op[Op["PUSHBYTES64"] = 64] = "PUSHBYTES64";
    Op[Op["PUSHBYTES65"] = 65] = "PUSHBYTES65";
    Op[Op["PUSHBYTES66"] = 66] = "PUSHBYTES66";
    Op[Op["PUSHBYTES67"] = 67] = "PUSHBYTES67";
    Op[Op["PUSHBYTES68"] = 68] = "PUSHBYTES68";
    Op[Op["PUSHBYTES69"] = 69] = "PUSHBYTES69";
    Op[Op["PUSHBYTES70"] = 70] = "PUSHBYTES70";
    Op[Op["PUSHBYTES71"] = 71] = "PUSHBYTES71";
    Op[Op["PUSHBYTES72"] = 72] = "PUSHBYTES72";
    Op[Op["PUSHBYTES73"] = 73] = "PUSHBYTES73";
    Op[Op["PUSHBYTES74"] = 74] = "PUSHBYTES74";
    Op[Op["PUSHBYTES75"] = 75] = "PUSHBYTES75";
    Op[Op["PUSHDATA1"] = 76] = "PUSHDATA1";
    Op[Op["PUSHDATA2"] = 77] = "PUSHDATA2";
    Op[Op["PUSHDATA4"] = 78] = "PUSHDATA4";
    Op[Op["PUSHM1"] = 79] = "PUSHM1";
    Op[Op["PUSH1"] = 81] = "PUSH1";
    Op[Op["PUSH2"] = 82] = "PUSH2";
    Op[Op["PUSH3"] = 83] = "PUSH3";
    Op[Op["PUSH4"] = 84] = "PUSH4";
    Op[Op["PUSH5"] = 85] = "PUSH5";
    Op[Op["PUSH6"] = 86] = "PUSH6";
    Op[Op["PUSH7"] = 87] = "PUSH7";
    Op[Op["PUSH8"] = 88] = "PUSH8";
    Op[Op["PUSH9"] = 89] = "PUSH9";
    Op[Op["PUSH10"] = 90] = "PUSH10";
    Op[Op["PUSH11"] = 91] = "PUSH11";
    Op[Op["PUSH12"] = 92] = "PUSH12";
    Op[Op["PUSH13"] = 93] = "PUSH13";
    Op[Op["PUSH14"] = 94] = "PUSH14";
    Op[Op["PUSH15"] = 95] = "PUSH15";
    Op[Op["PUSH16"] = 96] = "PUSH16";
    Op[Op["NOP"] = 97] = "NOP";
    Op[Op["JMP"] = 98] = "JMP";
    Op[Op["JMPIF"] = 99] = "JMPIF";
    Op[Op["JMPIFNOT"] = 100] = "JMPIFNOT";
    Op[Op["CALL"] = 101] = "CALL";
    Op[Op["RET"] = 102] = "RET";
    Op[Op["APPCALL"] = 103] = "APPCALL";
    Op[Op["SYSCALL"] = 104] = "SYSCALL";
    Op[Op["TAILCALL"] = 105] = "TAILCALL";
    Op[Op["DUPFROMALTSTACK"] = 106] = "DUPFROMALTSTACK";
    Op[Op["TOALTSTACK"] = 107] = "TOALTSTACK";
    Op[Op["FROMALTSTACK"] = 108] = "FROMALTSTACK";
    Op[Op["XDROP"] = 109] = "XDROP";
    Op[Op["XSWAP"] = 114] = "XSWAP";
    Op[Op["XTUCK"] = 115] = "XTUCK";
    Op[Op["DEPTH"] = 116] = "DEPTH";
    Op[Op["DROP"] = 117] = "DROP";
    Op[Op["DUP"] = 118] = "DUP";
    Op[Op["NIP"] = 119] = "NIP";
    Op[Op["OVER"] = 120] = "OVER";
    Op[Op["PICK"] = 121] = "PICK";
    Op[Op["ROLL"] = 122] = "ROLL";
    Op[Op["ROT"] = 123] = "ROT";
    Op[Op["SWAP"] = 124] = "SWAP";
    Op[Op["TUCK"] = 125] = "TUCK";
    Op[Op["CAT"] = 126] = "CAT";
    Op[Op["SUBSTR"] = 127] = "SUBSTR";
    Op[Op["LEFT"] = 128] = "LEFT";
    Op[Op["RIGHT"] = 129] = "RIGHT";
    Op[Op["SIZE"] = 130] = "SIZE";
    Op[Op["INVERT"] = 131] = "INVERT";
    Op[Op["AND"] = 132] = "AND";
    Op[Op["OR"] = 133] = "OR";
    Op[Op["XOR"] = 134] = "XOR";
    Op[Op["EQUAL"] = 135] = "EQUAL";
    Op[Op["OP_EQUALVERIFY"] = 136] = "OP_EQUALVERIFY";
    Op[Op["OP_RESERVED1"] = 137] = "OP_RESERVED1";
    Op[Op["OP_RESERVED2"] = 138] = "OP_RESERVED2";
    Op[Op["INC"] = 139] = "INC";
    Op[Op["DEC"] = 140] = "DEC";
    Op[Op["SIGN"] = 141] = "SIGN";
    Op[Op["NEGATE"] = 143] = "NEGATE";
    Op[Op["ABS"] = 144] = "ABS";
    Op[Op["NOT"] = 145] = "NOT";
    Op[Op["NZ"] = 146] = "NZ";
    Op[Op["ADD"] = 147] = "ADD";
    Op[Op["SUB"] = 148] = "SUB";
    Op[Op["MUL"] = 149] = "MUL";
    Op[Op["DIV"] = 150] = "DIV";
    Op[Op["MOD"] = 151] = "MOD";
    Op[Op["SHL"] = 152] = "SHL";
    Op[Op["SHR"] = 153] = "SHR";
    Op[Op["BOOLAND"] = 154] = "BOOLAND";
    Op[Op["BOOLOR"] = 155] = "BOOLOR";
    Op[Op["NUMEQUAL"] = 156] = "NUMEQUAL";
    Op[Op["NUMNOTEQUAL"] = 158] = "NUMNOTEQUAL";
    Op[Op["LT"] = 159] = "LT";
    Op[Op["GT"] = 160] = "GT";
    Op[Op["LTE"] = 161] = "LTE";
    Op[Op["GTE"] = 162] = "GTE";
    Op[Op["MIN"] = 163] = "MIN";
    Op[Op["MAX"] = 164] = "MAX";
    Op[Op["WITHIN"] = 165] = "WITHIN";
    Op[Op["SHA1"] = 167] = "SHA1";
    Op[Op["SHA256"] = 168] = "SHA256";
    Op[Op["HASH160"] = 169] = "HASH160";
    Op[Op["HASH256"] = 170] = "HASH256";
    Op[Op["CHECKSIG"] = 172] = "CHECKSIG";
    Op[Op["VERIFY"] = 173] = "VERIFY";
    Op[Op["CHECKMULTISIG"] = 174] = "CHECKMULTISIG";
    Op[Op["ARRAYSIZE"] = 192] = "ARRAYSIZE";
    Op[Op["PACK"] = 193] = "PACK";
    Op[Op["UNPACK"] = 194] = "UNPACK";
    Op[Op["PICKITEM"] = 195] = "PICKITEM";
    Op[Op["SETITEM"] = 196] = "SETITEM";
    Op[Op["NEWARRAY"] = 197] = "NEWARRAY";
    Op[Op["NEWSTRUCT"] = 198] = "NEWSTRUCT";
    Op[Op["NEWMAP"] = 199] = "NEWMAP";
    Op[Op["APPEND"] = 200] = "APPEND";
    Op[Op["REVERSE"] = 201] = "REVERSE";
    Op[Op["REMOVE"] = 202] = "REMOVE";
    Op[Op["HASKEY"] = 203] = "HASKEY";
    Op[Op["KEYS"] = 204] = "KEYS";
    Op[Op["VALUES"] = 205] = "VALUES";
    Op[Op["CALL_I"] = 224] = "CALL_I";
    Op[Op["CALL_E"] = 225] = "CALL_E";
    Op[Op["CALL_ED"] = 226] = "CALL_ED";
    Op[Op["CALL_ET"] = 227] = "CALL_ET";
    Op[Op["CALL_EDT"] = 228] = "CALL_EDT";
    Op[Op["THROW"] = 240] = "THROW";
    Op[Op["THROWIFNOT"] = 241] = "THROWIFNOT";
})(Op || (Op = {}));
export const Byte = Op;
export const ByteBuffer = _.fromPairs(Object.values(Op).map((byteCode) => [byteCode, Buffer.from([byteCode])]));
export const isByteCode = (value) => Op[value] !== undefined;
export const assertByteCode = (value) => {
    if (isByteCode(value)) {
        return value;
    }
    throw new InvalidVMByteCodeError(value);
};
export var SysCall;
(function (SysCall) {
    SysCall["System.Runtime.Platform"] = "System.Runtime.Platform";
    SysCall["Neo.Runtime.GetTrigger"] = "Neo.Runtime.GetTrigger";
    SysCall["Neo.Runtime.CheckWitness"] = "Neo.Runtime.CheckWitness";
    SysCall["Neo.Runtime.Notify"] = "Neo.Runtime.Notify";
    SysCall["Neo.Runtime.Log"] = "Neo.Runtime.Log";
    SysCall["Neo.Runtime.GetTime"] = "Neo.Runtime.GetTime";
    SysCall["Neo.Runtime.Serialize"] = "Neo.Runtime.Serialize";
    SysCall["Neo.Runtime.Deserialize"] = "Neo.Runtime.Deserialize";
    SysCall["Neo.Blockchain.GetHeight"] = "Neo.Blockchain.GetHeight";
    SysCall["Neo.Blockchain.GetHeader"] = "Neo.Blockchain.GetHeader";
    SysCall["Neo.Blockchain.GetBlock"] = "Neo.Blockchain.GetBlock";
    SysCall["Neo.Blockchain.GetTransaction"] = "Neo.Blockchain.GetTransaction";
    SysCall["Neo.Blockchain.GetTransactionHeight"] = "Neo.Blockchain.GetTransactionHeight";
    SysCall["Neo.Blockchain.GetAccount"] = "Neo.Blockchain.GetAccount";
    SysCall["Neo.Blockchain.GetValidators"] = "Neo.Blockchain.GetValidators";
    SysCall["Neo.Blockchain.GetAsset"] = "Neo.Blockchain.GetAsset";
    SysCall["Neo.Blockchain.GetContract"] = "Neo.Blockchain.GetContract";
    SysCall["Neo.Header.GetHash"] = "Neo.Header.GetHash";
    SysCall["Neo.Header.GetIndex"] = "Neo.Header.GetIndex";
    SysCall["Neo.Header.GetVersion"] = "Neo.Header.GetVersion";
    SysCall["Neo.Header.GetPrevHash"] = "Neo.Header.GetPrevHash";
    SysCall["Neo.Header.GetMerkleRoot"] = "Neo.Header.GetMerkleRoot";
    SysCall["Neo.Header.GetTimestamp"] = "Neo.Header.GetTimestamp";
    SysCall["Neo.Header.GetConsensusData"] = "Neo.Header.GetConsensusData";
    SysCall["Neo.Header.GetNextConsensus"] = "Neo.Header.GetNextConsensus";
    SysCall["Neo.Block.GetTransactionCount"] = "Neo.Block.GetTransactionCount";
    SysCall["Neo.Block.GetTransactions"] = "Neo.Block.GetTransactions";
    SysCall["Neo.Block.GetTransaction"] = "Neo.Block.GetTransaction";
    SysCall["Neo.Transaction.GetHash"] = "Neo.Transaction.GetHash";
    SysCall["Neo.Transaction.GetType"] = "Neo.Transaction.GetType";
    SysCall["Neo.Transaction.GetAttributes"] = "Neo.Transaction.GetAttributes";
    SysCall["Neo.Transaction.GetInputs"] = "Neo.Transaction.GetInputs";
    SysCall["Neo.Transaction.GetOutputs"] = "Neo.Transaction.GetOutputs";
    SysCall["Neo.Transaction.GetReferences"] = "Neo.Transaction.GetReferences";
    SysCall["Neo.Transaction.GetUnspentCoins"] = "Neo.Transaction.GetUnspentCoins";
    SysCall["Neo.Transaction.GetWitnesses"] = "Neo.Transaction.GetWitnesses";
    SysCall["Neo.InvocationTransaction.GetScript"] = "Neo.InvocationTransaction.GetScript";
    SysCall["Neo.Attribute.GetUsage"] = "Neo.Attribute.GetUsage";
    SysCall["Neo.Attribute.GetData"] = "Neo.Attribute.GetData";
    SysCall["Neo.Input.GetHash"] = "Neo.Input.GetHash";
    SysCall["Neo.Input.GetIndex"] = "Neo.Input.GetIndex";
    SysCall["Neo.Output.GetAssetId"] = "Neo.Output.GetAssetId";
    SysCall["Neo.Output.GetValue"] = "Neo.Output.GetValue";
    SysCall["Neo.Output.GetScriptHash"] = "Neo.Output.GetScriptHash";
    SysCall["Neo.Account.GetScriptHash"] = "Neo.Account.GetScriptHash";
    SysCall["Neo.Account.GetVotes"] = "Neo.Account.GetVotes";
    SysCall["Neo.Account.GetBalance"] = "Neo.Account.GetBalance";
    SysCall["Neo.Account.IsStandard"] = "Neo.Account.IsStandard";
    SysCall["Neo.Asset.GetAssetId"] = "Neo.Asset.GetAssetId";
    SysCall["Neo.Asset.GetAssetType"] = "Neo.Asset.GetAssetType";
    SysCall["Neo.Asset.GetAmount"] = "Neo.Asset.GetAmount";
    SysCall["Neo.Asset.GetAvailable"] = "Neo.Asset.GetAvailable";
    SysCall["Neo.Asset.GetPrecision"] = "Neo.Asset.GetPrecision";
    SysCall["Neo.Asset.GetOwner"] = "Neo.Asset.GetOwner";
    SysCall["Neo.Asset.GetAdmin"] = "Neo.Asset.GetAdmin";
    SysCall["Neo.Asset.GetIssuer"] = "Neo.Asset.GetIssuer";
    SysCall["Neo.Contract.GetScript"] = "Neo.Contract.GetScript";
    SysCall["Neo.Contract.IsPayable"] = "Neo.Contract.IsPayable";
    SysCall["Neo.Storage.GetContext"] = "Neo.Storage.GetContext";
    SysCall["Neo.Storage.GetReadOnlyContext"] = "Neo.Storage.GetReadOnlyContext";
    SysCall["Neo.Storage.Get"] = "Neo.Storage.Get";
    SysCall["Neo.Storage.Find"] = "Neo.Storage.Find";
    SysCall["Neo.StorageContext.AsReadOnly"] = "Neo.StorageContext.AsReadOnly";
    SysCall["Neo.Enumerator.Create"] = "Neo.Enumerator.Create";
    SysCall["Neo.Iterator.Create"] = "Neo.Iterator.Create";
    SysCall["Neo.Enumerator.Next"] = "Neo.Enumerator.Next";
    SysCall["Neo.Iterator.Key"] = "Neo.Iterator.Key";
    SysCall["Neo.Enumerator.Value"] = "Neo.Enumerator.Value";
    SysCall["Neo.Enumerator.Concat"] = "Neo.Enumerator.Concat";
    SysCall["Neo.Iterator.Concat"] = "Neo.Iterator.Concat";
    SysCall["Neo.Iterator.Keys"] = "Neo.Iterator.Keys";
    SysCall["Neo.Iterator.Values"] = "Neo.Iterator.Values";
    SysCall["Neo.Account.SetVotes"] = "Neo.Account.SetVotes";
    SysCall["Neo.Validator.Register"] = "Neo.Validator.Register";
    SysCall["Neo.Asset.Create"] = "Neo.Asset.Create";
    SysCall["Neo.Asset.Renew"] = "Neo.Asset.Renew";
    SysCall["Neo.Contract.Create"] = "Neo.Contract.Create";
    SysCall["Neo.Contract.Migrate"] = "Neo.Contract.Migrate";
    SysCall["Neo.Contract.GetStorageContext"] = "Neo.Contract.GetStorageContext";
    SysCall["Neo.Contract.Destroy"] = "Neo.Contract.Destroy";
    SysCall["Neo.Storage.Put"] = "Neo.Storage.Put";
    SysCall["Neo.Storage.PutEx"] = "Neo.Storage.PutEx";
    SysCall["Neo.Storage.Delete"] = "Neo.Storage.Delete";
    SysCall["Neo.Witness.GetVerificationScript"] = "Neo.Witness.GetVerificationScript";
    SysCall["System.ExecutionEngine.GetScriptContainer"] = "System.ExecutionEngine.GetScriptContainer";
    SysCall["System.ExecutionEngine.GetExecutingScriptHash"] = "System.ExecutionEngine.GetExecutingScriptHash";
    SysCall["System.ExecutionEngine.GetCallingScriptHash"] = "System.ExecutionEngine.GetCallingScriptHash";
    SysCall["System.ExecutionEngine.GetEntryScriptHash"] = "System.ExecutionEngine.GetEntryScriptHash";
})(SysCall || (SysCall = {}));
const isSysCall = (value) => SysCall[value] !== undefined;
export const assertSysCall = (value) => {
    if (isSysCall(value)) {
        return value;
    }
    throw new InvalidSysCallError(value);
};
export var VMState;
(function (VMState) {
    VMState[VMState["None"] = 0] = "None";
    VMState[VMState["Halt"] = 1] = "Halt";
    VMState[VMState["Fault"] = 2] = "Fault";
    VMState[VMState["Break"] = 4] = "Break";
})(VMState || (VMState = {}));
const isVMState = (state) => VMState[state] !== undefined;
export const assertVMState = (state) => {
    if (isVMState(state)) {
        return state;
    }
    throw new InvalidVMStateError(state);
};
export const sha256 = (value) => createHash('sha256').update(value).digest();
const mutableCache = {};
export const toSysCallHash = (value) => {
    let hash = mutableCache[value];
    if (hash === undefined) {
        mutableCache[value] = hash = sha256(Buffer.from(value, 'ascii')).readUInt32LE(0);
    }
    return hash;
};

//# sourceMappingURL=vm.js.map
